import {useEffect, useState} from 'react';
import {Modal, Button, Form, Input, Switch,  Popconfirm, message} from 'antd';
import {useApi} from "../provider/ApiProvider";

const layout = {
    labelCol: { span: 10 },
    wrapperCol: { span: 16 },
};

const {TextArea} = Input;

export default function SupportDialog({open, data, onChange, onClose}){

    const {api, successHandling} = useApi();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        console.log(data, 'dataa');
        form.setFieldsValue(data);
    },[data])

    const handleOk = () => {

    };

    const handleCancel = () => {
        onClose()
    };

    const onFinish = (values) => {
        api.post('/supportRouter/support/update/'+data.id, values).then(resp => {
            onClose();
            onChange();
            sendNotification(data.User.id);
        })

    };

    async function sendNotification(userId){
        setLoading(true);

        await api.post('/notificationRouter/sendForUser',{
            userId: userId,
            title: "Destek talebiniz cevaplandı",
            message: "Destek talebiniz cevaplandı.Lütfen profilinizden kontrol ediniz.",

        }).then(resp => {
            successHandling("Bildirim başarıyla gönderildi");
            setLoading(false);

        }).finally(() => {
            setLoading(false);
        })
    }

    const onFinishFailed = (errorInfo) => {

    }

    const onDelete = (record) => {


    }



    return (
        <Modal
            title={"Cevap Ver"}
            visible={open} okType={"submit"}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={[
                <Button  key="back" onClick={handleCancel}>
                    İptal
                </Button>,


                <Button  form="company-dialog-form" htmlType="submit" key="submit" type="primary" loading={loading} onClick={handleOk}>
                    Kaydet
                </Button>,
            ]}
        >
            <div style={{borderBottom: '1px solid gray', marginBottom: '10px'}}>
                <p>Kullanıcı Mesajı: {data?.content}</p>

            </div>
            <Form
                form={form}
                id="company-dialog-form"
                onFinish={onFinish}
                onFinishFailed={() => onFinishFailed("İstenen bilgileri giriniz")}
                initialValues={data}
            >
                <Form.Item
                    label="Cevap"
                    name="answer"
                    rules={[
                        {
                            required: true,
                            message: 'Bu alanı doldurunuz',
                        },
                    ]}
                >
                    <TextArea rows={4}/>
                </Form.Item>



            </Form>
        </Modal>

    )
}
